// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 798) return "static/chunks/798.9b484c3179acd288.js";
	if (chunkId === 54) return "static/chunks/54.df9597e9cb583558.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"190":"55f688d18e909428","225":"57671f315ae3f6d7","745":"7661b5450825584d","812":"14bc97d1c30cd567","939":"163c022470a9e51a","980":"a2eba98f9a185aa7"}[chunkId] + ".js";
};